import React, { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import ActivityType from '@components/profile/profileOverlay/overlays/experience/experienceWrite/activityForm/ActivityType';
import ActivityPeriod from '@components/profile/profileOverlay/overlays/experience/experienceWrite/activityForm/ActivityPeriod';
import ActivityDescription from '@components/profile/profileOverlay/overlays/experience/experienceWrite/activityForm/ActivityDescription';
import styles from '../../experience.module.scss';
import { ExperienceFromVO } from '@domain/vo/profile/ProfileExperienceFormVO';

import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IActivityItemProps {
  index: number;
  prefixName: string;
  onDeleteItem: () => void;
}

const ActivityItem = ({ index, prefixName, onDeleteItem }: IActivityItemProps) => {
  const { watch } = useFormContext();
  const isDisabledDeleteBtn = index == 0 && Object.values(watch(prefixName) ?? {}).filter((v) => !!v).length === 0;

  return (
    <div className={cx('activityInner')}>
      <button className={cx('btnDelete')} type="button" disabled={isDisabledDeleteBtn} onClick={onDeleteItem}>
        <Icon name="deleteLight" width={20} height={20} />
        삭제
      </button>

      <ActivityType prefixName={prefixName} />
      <ActivityPeriod prefixName={prefixName} />
      <ActivityDescription prefixName={prefixName} />
    </div>
  );
};

interface IActivityFormProps {
  visible: boolean;
}
const ActivityForm = ({ visible }: IActivityFormProps) => {
  const { control } = useFormContext();

  const fieldName = 'activities';
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const onAppendActivity = () => {
    append(
      new ExperienceFromVO({
        tag: null,
        code: null,
        title: '',
        startDate: '',
        endDate: '',
        description: '',
      }),
    );
  };

  const activitiesEls = fields.map((field, idx) => {
    const prefixName = `${fieldName}.[${idx}]`;
    const onDeleteItem = () => {
      remove(idx);
    };

    return <ActivityItem key={field.id} index={idx} prefixName={prefixName} onDeleteItem={onDeleteItem} />;
  });

  useEffect(() => {
    if (fields.length === 0) {
      onAppendActivity();
    }
  }, [fields.length]);

  return (
    <div className={cx('activityArea', { hidden: !visible })}>
      <em className={cx('sectionTitle')}>대내외 활동</em>
      {activitiesEls}

      <a className={cx('btnAdd')} role="button" onClick={onAppendActivity}>
        <Icon name="addLight" width={24} height={24} />
        추가
      </a>
    </div>
  );
};

export default ActivityForm;
